import { useEffect, useState } from 'react';

function DisplayImages() {
  const [images, setImages] = useState([]);

  useEffect(() => {
    fetch("http://localhost:5000/images")
      .then(response => response.json())
      .then(data => setImages(data))
      .catch(error => console.error("Error fetching images:", error));
  }, []);

  return (
    <div>
      <h2>Uploaded Images</h2>
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {images.map((img) => (
          <div key={img.id} style={{ margin: "10px", textAlign: "center" }}>
            <img src={`http://localhost:5000${img.image_link}`} alt={img.image_name} width="200" />
            <p>{img.image_name}</p>
            <p>{new Date(img.created_at).toLocaleString()}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default DisplayImages;
